
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");
import {getYourInformationResults} from "@/components/utils/PopulateForms/PopulateCommonInformation";
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { locationInfoDataInfoType, existingOrdersInfoType } from '@/types/Application/FamilyLawMatter/Pdf';
import { yourInformationInfoDataInfoType, childrenInfoSurveyInfoType } from '@/types/Application/CommonInformation/Pdf';
import { rflmBackgroundSurveyDataInfoType, rflmQuestionnaireDataInfoType } from '@/types/Application/ReplyFamilyLawMatter';
import { agreeDisagreeInfoType } from '@/types/Application/ReplyFamilyLawMatter/Pdf';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})
export default class CommonSection extends Vue {

    @Prop({required:true})
    result!: any;

    @Prop({required:true})
    selectedSchedules!: string[];  

    @Prop({required:true})
    agreeDisagreeResults!: agreeDisagreeInfoType;
    
    dataReady = false;
    includesCounter = false;
    aboutChildren = false;
    counterAboutChildren = false;

    locationInfo = {} as locationInfoDataInfoType;

    otherPartyInfo='';
    yourInfo = {} as yourInformationInfoDataInfoType;
    
    existingOrders = {} as existingOrdersInfoType;    
   
    childrenInfo = []
    counterChildrenInfo = []
    childBestInterestAcknowledmentCheck = false;
    childBestInterestAcknowledmentCheckCounter = false;
    incorrectChildInfo = false;
    culturalInfo = '';
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;
    }

    childrenCorrectionFields=[
        {key:"fullName",               label:"Child's full name",                      tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:30%;"},
        {key:"dob",                    label:"Child's date of birth (mmm/dd/yyyy)",    tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},
    ]  
   
    childrenFields=[
        {key:"fullName",               label:"Child's full name",                      tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:30%;"},
        {key:"dob",                    label:"Child's date of birth (mmm/dd/yyyy)",    tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},
        {key:"myRelationship",         label:"My relationship to the child",           tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},        
        {key:"otherPartyRelationship", label:"Other party's relationship to the child",tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:21%;"},
        {key:"currentSituation",       label:"Child is currently living with",         tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:16%;"},
    ]   

    public extractInfo(){     

        this.includesCounter = this.result.rflmCounterAppSurvey.counter == 'Yes';
        
        this.existingOrders = this.getExistingOrdersInfo();
        const rflmQuestionnaireInfo: rflmQuestionnaireDataInfoType = this.result.rflmQuestionnaireSurvey;
        const counterList: string[] = this.result.rflmCounterAppSurvey?.counterList;    
        
        const childRelatedApplication = ( 
            rflmQuestionnaireInfo.selectedParentingArrangementsForm.length > 0 || 
            rflmQuestionnaireInfo.selectedChildSupportForm.length > 0 ||
            rflmQuestionnaireInfo.selectedContactWithChildForm.length > 0 || 
            rflmQuestionnaireInfo.selectedGuardianshipForm.length > 0 
        )

        if (childRelatedApplication){
            this.aboutChildren = true;
            this.incorrectChildInfo = this.result.correctChildInfo == 'No';
            if (this.incorrectChildInfo && this.result.childrenInfoSurvey?.length > 0){           
                this.childrenInfo = this.getChildrenInfo();
            } else {
                this.childrenInfo = [{fullName: '', dob:'', myRelationship: '', otherPartyRelationship: '', currentSituation: ''}];
            }
            this.childBestInterestAcknowledmentCheck = this.result.rflmChildBestInterestAcknowledgement;
                       
        } else {
            this.aboutChildren = false;
            this.childrenInfo = [{fullName: '', dob:'', myRelationship: '', otherPartyRelationship: '', currentSituation: ''}];
            this.childBestInterestAcknowledmentCheck = false;
            this.incorrectChildInfo = false;
        }        

        const childRelatedCounterApplication = this.includesCounter && (
            counterList.includes('parentingArrangements') ||
            counterList.includes('childSupport') || 
            counterList.includes('contactWithChild') ||
            counterList.includes('guardianOfChild'))

        if (childRelatedCounterApplication && this.result.childrenInfoSurvey?.length > 0){
            this.counterAboutChildren = true;
            this.counterChildrenInfo = this.getChildrenInfo();
            this.childBestInterestAcknowledmentCheckCounter = this.result.rflmChildBestInterestAcknowledgement;            
        } else {
            this.counterAboutChildren = false;
            this.counterChildrenInfo = [{fullName: '', dob:'', myRelationship: '', otherPartyRelationship: '', currentSituation: ''}];
            this.childBestInterestAcknowledmentCheckCounter = false;
        }        

        if (this.result.rflmBackgroundSurvey?.likeToAddCulturalExplanation == 'y' && this.result.rflmBackgroundSurvey?.culturalExplain){
            this.culturalInfo = this.result.rflmBackgroundSurvey.culturalExplain;
        } else {
            this.culturalInfo = '';
        } 
        
        this.otherPartyInfo = this.getOtherPartyInfo();
        this.yourInfo = this.getYourInfo();     
        this.locationInfo = this.getLocationInfo();  
    }

    public getLocationInfo(){

        const locationInformation = {} as locationInfoDataInfoType;
        if (this.result.filingLocationSurvey){
            const locationData = this.result.filingLocationSurvey;
           
            locationInformation.existingFileNumber = locationData?.ExistingFileNumber && locationData?.ExistingFamilyCase =='y'? locationData.ExistingFileNumber:'';
            locationInformation.courtLocation = locationData?.ExistingCourt? locationData.ExistingCourt:'';

            locationInformation.earlyResolutionRegistry = locationData.earlyResolutionRegistry;
            locationInformation.familyJusticeRegistry = locationData.familyJusticeRegistry;
            locationInformation.educationRegistry = locationData.familyEducationProgram;  
            locationInformation.none = !(locationInformation.educationRegistry
                                        || locationInformation.familyJusticeRegistry
                                        || locationInformation.earlyResolutionRegistry);
        }
        
        return locationInformation;
    }
    
    public getChildrenInfo(){

        const childrenInfo: childrenInfoSurveyInfoType[] = [];
        let childInfo = {} as childrenInfoSurveyInfoType;
        const childData = this.result.childrenInfoSurvey;
       
        for (const child of childData){            
            childInfo = {fullName: '', dob:'', myRelationship: '', otherPartyRelationship: '', currentSituation: ''};
            childInfo.fullName = Vue.filter('getFullName')(child.name);
            childInfo.dob = Vue.filter('beautify-date')(child.dob);
            childInfo.myRelationship = child.relation;
            childInfo.otherPartyRelationship = child.opRelation;
            childInfo.currentSituation = child.currentLiving;
            childrenInfo.push(childInfo)
        }    
       
        return childrenInfo;
    }

    public getExistingOrdersInfo(){
        const existing = {existingFlm: false, existingPO: false}

        if (this.result.rflmBackgroundSurvey){
            const backgroundInfo: rflmBackgroundSurveyDataInfoType = this.result.rflmBackgroundSurvey
            existing.existingFlm = backgroundInfo.ExistingOrdersFLM == 'y' || backgroundInfo.otherPartyAttach == 'n';
            existing.existingPO =  backgroundInfo.existingPOOrdersAttached == 'n';
        }        

        return existing;
    }

    public getYourInfo(){

        if(this.result?.yourInformationSurvey){
            return getYourInformationResults(this.result?.yourInformationSurvey); 
        } 
        else
            return {} as yourInformationInfoDataInfoType
    }

    public getOtherPartyInfo(){

        let OpInformation = [
            {  
                name: {'first': '','middle': '', 'last': ''}                
            }               
        ];        

        if (this.result.otherPartyCommonSurvey?.length > 0){
            OpInformation = [];    
            for(const party of this.result.otherPartyCommonSurvey){
                if (party.name){
                    const otherParty = Vue.filter('getFullName')(party.name)
                    OpInformation.push(otherParty)
                }                    
            }
        } 

        return OpInformation.join(', ')
    }    
 
}
